import { render, staticRenderFns } from "./ArchiveArticles.vue?vue&type=template&id=4a981286&scoped=true&"
import script from "./ArchiveArticles.vue?vue&type=script&lang=js&"
export * from "./ArchiveArticles.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveArticles.vue?vue&type=style&index=0&id=4a981286&prod&lang=css&"
import style1 from "./ArchiveArticles.vue?vue&type=style&index=1&id=4a981286&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a981286",
  null
  
)

export default component.exports